import type { RouteRecordRaw } from 'vue-router'
import { routeNames } from './route-names'
import { ERoleType } from '@/types/enums'

import { authRoutes } from '@/views/auth/auth.routes.ts'
import { spencerAdminRoutes } from '@/views/spencer-admin/spencer-admin.routes.ts'
import { schoolAdminRoutes } from '@/views/school-admin/schools-admin.routes.ts'
import { needManagerRoutes } from '@/views/need-manager/need-manager.routes.ts'
import { professionalRoutes } from '@/views/professional/professional.routes'
import { settingsRoutes } from '@/views/settings/settings.routes.ts'
import { uiKitRoutes } from '@/views/ui-kit/ui-kit.routes'

import Default from '@/layouts/Default.vue'
import Auth from '@/layouts/Auth.vue'
import { studentsRoutes } from '@/features/students/students.routes'

const authLayoutRoutes: RouteRecordRaw = {
  path: '/auth',
  redirect: { name: routeNames.login },
  component: Auth,
  children: authRoutes,
  meta: {
    notRequireAuth: true
  }
}

const spencerAdminLayoutRoutes: RouteRecordRaw = {
  path: '/spencer-admin',
  redirect: { name: routeNames.spencerAdminSchools },
  name: routeNames.spencerAdmin,
  component: Default,
  children: spencerAdminRoutes,
  meta: {
    allowedRole: ERoleType.spencerAdmin
  }
}

const schoolAdminLayoutRoutes: RouteRecordRaw = {
  path: '/school-admin',
  redirect: { name: routeNames.schoolAdminStudents },
  name: routeNames.schoolAdmin,
  component: Default,
  children: schoolAdminRoutes,
  meta: {
    allowedRole: ERoleType.schoolAdmin
  }
}

const needManagerLayoutRoutes: RouteRecordRaw = {
  path: '/need-manager',
  redirect: { name: routeNames.needManagerHomeQuestionnaires },
  name: routeNames.needManager,
  component: Default,
  children: needManagerRoutes,
  meta: {
    allowedRole: ERoleType.needManager
  }
}

const professionalLayoutRoutes: RouteRecordRaw = {
  path: '/professional',
  redirect: { name: routeNames.professionalHomeQuestionnaires },
  name: routeNames.professional,
  component: Default,
  children: professionalRoutes,
  meta: {
    allowedRole: ERoleType.professional
  }
}

const settingsLayoutRoutes: RouteRecordRaw = {
  path: '/settings',
  redirect: { name: routeNames.settingsProfile },
  name: routeNames.settings,
  component: Default,
  children: settingsRoutes
}

const studentsLayoutRoutes: RouteRecordRaw = {
  path: '/students',
  redirect: { name: routeNames.studentProfile },
  name: routeNames.students,
  component: Default,
  children: studentsRoutes
}

const uiKitLayoutRoutes: RouteRecordRaw = {
  path: '/ui-kit',
  redirect: { name: routeNames.charts },
  name: routeNames.uiKit,
  component: Default,
  children: uiKitRoutes
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { name: routeNames.spencerAdmin }
  },
  authLayoutRoutes,
  spencerAdminLayoutRoutes,
  schoolAdminLayoutRoutes,
  needManagerLayoutRoutes,
  professionalLayoutRoutes,
  settingsLayoutRoutes,
  studentsLayoutRoutes,
  uiKitLayoutRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

export {
  routes
}
